export const asyncLanguages: Record<string, () => unknown> = {
	en: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/global-shortcuts-i18n-en" */ '../../i18n/en'
		),
};
